import { planTypes } from '@/common/constants';

export default {
  data() {
    return {
      logo: require('@/assets/plans/hardware_desk_phones.svg'),
      title: 'Desk Phones & Headsets',
      planType: planTypes.ZOOM_DEVICE,
      configDescription: 'configDescription',
      // same with desk phones addon desc.
      description: this.$t('billing.hw.desk_phones.addon.desc'),
    };
  }
};
